// 设备定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 设备状态
 */
class State extends UltMeta {
    DISABLED = new Meta(0, "禁用");
    ENABLE = new Meta(1, "启用");
}

export const STATE = new State();

/**
 * 设备类型
 */
class Type extends UltMeta {
    CAMERA = new Meta(1, "摄像头");
    GPS = new Meta(2, "GPS");
}

export const TYPE = new Type();

/**
 * 操作类型
 */
class OperationType extends UltMeta {
    DISABLED = new Meta(0, "禁用");
    ENABLED = new Meta(1, "启用");
}

export const OPERATION_TYPE = new OperationType();

/**
 * 运输工具类型
 */
class TransportType extends UltMeta {
    SHIP = new Meta(1, "船舶");
    CAR = new Meta(2, "汽车");
}

export const TRANSPORT_TYPE = new TransportType();

/**
 * 是否在线
 */
class Online extends UltMeta {
    OFFLINE = new Meta(0, "离线");
    ONLINE = new Meta(1, "在线");
}

export const ONLINE_STATUS = new Online();

/**
 * 设备归属者
 */
class DeviceBelong extends UltMeta {
    MINE = new Meta(0, "我的");
    OTHER = new Meta(1, "他人");
}

export const DEVICE_BELONG = new DeviceBelong();
